// import React from "react";
// import "./ShopInfoMain/ShopInfoMain.css";
// import { Carousel } from "react-responsive-carousel";
// import "react-responsive-carousel/lib/styles/carousel.min.css";
// import { Link } from "react-router-dom";

// export const ShopImg = ({product}) => {

//   const handleCarouselChange = (index) => {
//     (product.slice(index, index + 4));
//   };

//   return (
//     <div className="shopimgflex mt-0 md:mt-5">
//         <ul className="flex mt-3 mb-5  title-in-shoppage flex-wrap justify-center md:justify-center lg:justify-center ">
//         <li className="uppercase tracking-widest text-xs"><Link to="/">Home</Link></li>
//         <li className="dot-breadceumb uppercase tracking-widest text-xs"><Link to="/category">Product</Link></li>
//         <li className="dot-breadceumb  uppercase tracking-widest text-xs "><>{product[0]?.prdname}</></li>
//       </ul>
//       <Carousel
//         className="shopslider"
//         onChange={handleCarouselChange}
//         showArrows={true}
//         showThumbs={true}

//          preventMovementUntilSwipeScrollTolerance={50}
//       >
//         {product?.map((product, productIndex) =>
//           product.prdimg &&
//           JSON.parse(product?.prdDetalis).map((image, imageIndex) => (
//             <div key={`${productIndex}-${imageIndex}`} className="h-full w-full">
//               <img
//                 src={image?.url}
//                 alt={product?.title}
//                 style={{ width: "100%", height: "100%" }}
//               />
//             </div>
//           ))
//         )}
//       </Carousel>
//     </div>

//   );
// };

import React from "react";
import "./ShopInfoMain/ShopInfoMain.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";

export const ShopImg = ({ product }) => {
  const handleCarouselChange = (index) => {
    product.slice(index, index + 4);
  };

  return (
    <div className="shopimgflex mt-0 md:mt-5">
      {/* Breadcrumb Navigation */}
      <ul className="flex mt-3 mb-5 title-in-shoppage flex-wrap justify-center md:justify-center lg:justify-center">
        <li className="uppercase tracking-widest text-xs">
          <Link to="/">Home</Link>
        </li>
        <li className="dot-breadceumb uppercase tracking-widest text-xs">
          <Link to="/category">Product</Link>
        </li>
        <li className="dot-breadceumb uppercase tracking-widest text-xs">
          <>{product[0]?.prdname}</>
        </li>
      </ul>

      {/* Product Carousel */}
      <Carousel
        className="shopslider"
        onChange={handleCarouselChange}
        showArrows={true}
        showThumbs={true}
        preventMovementUntilSwipeScrollTolerance={50}
      >
        {product?.map(
          (product, productIndex) =>
            product.prdimg &&
            JSON.parse(product?.prdDetalis).map((media, mediaIndex) => {
              const isVideo = media.url.includes(".mp4");


              return (
                <div
                  key={`${productIndex}-${mediaIndex}`}
                  className="h-full w-full"
                >
                  {isVideo ? (
                    <video controls style={{ width: "100%", height: "100%" }} autoPlay muted loop>
                      <source src={media.url} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : (
                    <img
                      src={media.url}
                      alt={product?.title}
                      style={{ width: "100%", height: "100%" }}
                    />
                  )}
                </div>
              );
            })
        )}
      </Carousel>
    </div>
  );
};
